// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TopLoadingBar(Props) {
  let color = Props.color;
  let height = Props.height;
  let state = Props.state;
  const match = React.useState(function () {
    return 0;
  });
  const setWidth = match[1];
  const width = match[0];
  const match$1 = React.useState(function () {
    return false;
  });
  const setFinished = match$1[1];
  const finished = match$1[0];
  React.useEffect((function () {
    let interval;
    interval = state === /* Start */ 0 ? setTimeout((function (param) {
        if (finished) {
          Curry._1(setFinished, (function (param) {
            return false;
          }));
        }
        if (window.innerWidth > (width + 10 | 0)) {
          return Curry._1(setWidth, (function (param) {
            return width + 3 | 0;
          }));
        }
        
      }), 1) : setTimeout((function (param) {
        if (!finished && window.innerWidth <= width) {
          Curry._1(setFinished, (function (param) {
            return true;
          }));
        }
        if (window.innerWidth > width && !finished) {
          return Curry._1(setWidth, (function (param) {
            return width + 3 | 0;
          }));
        } else {
          return Curry._1(setWidth, (function (param) {
            return 0;
          }));
        }
      }), 1);
    return (function (param) {
      clearTimeout(interval);
    });
  }), [
    state,
    width
  ]);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("svg", {
      children: JsxRuntime.jsx("line", {
        stroke: color,
        strokeWidth: String(height),
        x1: "0",
        x2: String(width),
        y1: Stdlib.string_of_float(height / 2),
        y2: Stdlib.string_of_float(height / 2)
      }),
      height: String(height),
      width: String(width),
      xmlns: "http://www.w3.org/2000/svg"
    }),
    className: "fixed"
  });
}

const make = TopLoadingBar;

export {
  make,
}
/* react Not a pure module */
